export default __webpack_public_path__ + "static/safari-pinned-tab-a011232dfdc5e76c174f11c053b95d82.svg";